// @ts-strict-ignore
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { LMChartBase } from './lm-chart-base';
import { SohoRadarComponent } from 'ids-enterprise-ng';

@Component({
  selector: 'lm-chart-radar',
  template: `
    <div soho-radar
        [dataset]="dataset"
        [redrawOnResize]="true"
        [showLegend]="showLegend"
        [emptyMessage]="{title: 'No Data Available', info: 'No Data Available', icon: 'icon-empty-no-data-new'}"
        [showAxisLabels]="showAxisLabels"
        [tooltip]="tooltip"

        (selected)="onSelected($event)"
        (rendered)="onRendered($event)"
        (unselected)="onUnselected($event)"
        (contextmenu)="onContextMenu($event)"
    ></div>
    <!-- FOR GAP CHART
       (margin)="<xxx>", (levels)="<xxx>", (maxValue)="<xxx>", (labelFactor)="<xxx>", (wrapWidth)="<xxx>", (opacityArea)="<xxx>",
       (dotRadius)="<xxx>", (opacityCircles)="<xxx>", (strokeWidth)="<xxx>", (roundStrokes)="<xxx>", (showCrosslines)="<xxx>",
       (colors)="<xxx>", (tooltip)="<xxx>", (axisFormatter)="<xxx>", [legendPlacement]="bottom"
    -->
            `
})
export class LMChartRadarComponent extends LMChartBase {
  @ViewChild(SohoRadarComponent, { static: true }) sohoRadarComponent: SohoRadarComponent;

  @Input() showAxisLabels: boolean;

  constructor(
    public elementRef: ElementRef,
  ) {
    super(elementRef);
  }

  public getChartComponent() {
    return this.sohoRadarComponent;
  }
}
